import React, { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import ProductGrid from '../common/ProductGrid';
import CartModal from '../Mainpage/CartModal';
import LoginModal from '../Mainpage/LoginModal';
import useProducts from '../Admin/useProducts';
import useCartActions from '../../hooks/useCartActions';
import useWishlist from '../../hooks/useWishlist';

/**
 * "Hot products" rail. Rendered both as its own route and inside the
 * landing page, so it must never take over the viewport while loading.
 */
const HotProducts = ({ limit = 10, layout = 'grid' }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const filters = useMemo(
    () => ({
      category_code: params.get('category') || '',
      product_guide: params.get('guide') || '',
      price_min: params.get('price_min') || '',
      price_max: params.get('price_max') || '',
      cut: params.get('cut') || '',
      shape: params.get('shape') || '',
      min_price: null,
      max_price: null,
      per_page: limit,
      hot: params.get('type') || 'hot',
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.search, limit]
  );

  const [loginShow, setLoginShow] = useState(false);
  const [showCart, setShowCart] = useState(false);

  const { products, loading, error, fetchProducts } = useProducts(filters);

  const openLogin = useCallback(() => setLoginShow(true), []);
  const { addToCart, pendingVariantId } = useCartActions({
    onCartOpen: () => setShowCart(true),
    onLoginRequired: openLogin,
  });
  const { isWishlisted, toggleWishlist, pendingCode } = useWishlist({
    onLoginRequired: openLogin,
  });

  const closeModals = useCallback(() => {
    setLoginShow(false);
    setShowCart(false);
  }, []);

  return (
    <>
      <ProductGrid
        products={products}
        loading={loading}
        error={error}
        onRetry={() => fetchProducts(1)}
        skeletonCount={limit}
        layout={layout}
        emptyTitle="No hot products right now"
        emptyDescription="Check back soon — our best sellers change often."
        isWishlisted={isWishlisted}
        onToggleWishlist={toggleWishlist}
        wishlistPending={pendingCode}
        onAddToCart={addToCart}
        cartPending={pendingVariantId}
      />

      <LoginModal show={loginShow} onClose={closeModals} />
      <CartModal show={showCart} onClose={closeModals} />
    </>
  );
};

export default HotProducts;
